import React from 'react';
import { Form, Button, Input, message, Select } from 'antd';
import InputRules from '../../data/InputRules';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';

const layout = {
	labelCol: {
		span: 4,
	},
	wrapperCol: {
		span: 8,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 4,
		span: 16,
	},
};

const MetaDataForm = ({ addMetaData, fetchMetaData }) => {
	const onFinish = async (values) => {
		await addMetaData(values);
		fetchMetaData();
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	return (
		<Form
			{...layout}
			name="metaDataForm"
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
		>
			<Form.Item label="Unique Name" name="id" rules={InputRules.required('Please enter unique name!')}>
				<Input placeholder="Enter unique name" />
			</Form.Item>
			<Form.Item label="Path URL" name="url" rules={InputRules.required('Please enter path url!')}>
				<Input placeholder="Enter path url" />
			</Form.Item>
			<Form.Item label="Title" name="title" rules={InputRules.required('Please enter title!')}>
				<Input placeholder="Enter title" />
			</Form.Item>
			<Form.Item label="Desription" name="description" rules={InputRules.required('Please enter description!')}>
				<Input placeholder="Enter description" />
			</Form.Item>
			<Form.Item label="Keywords" name="keywords" rules={InputRules.required('Please enter keywords!')}>
				<Select mode="tags"></Select>
			</Form.Item>
			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit">
					Add Meta Data
				</Button>
			</Form.Item>
		</Form>
	);
};

const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) => ({
	addMetaData: (body) => dispatch(Actions.addMetaData(body)),
	fetchMetaData: () => dispatch(Actions.fetchMetaData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MetaDataForm);
